const MODULE_NAME = 'keresoService';
class KeresoService {
	constructor($http, environment, $q) {
		'ngInject';
		this._$http = $http;
		this._$q = $q;
		this._environment = environment;
	}
	autoSuggest(term) {
		let searchObj = {
			lang: 'hu',
			siteId: 'otpagrar',
			token: term
		};
		return this._$http.jsonp(`${this._environment.backendUrl}/do/suggestionProxy`, {
			params: searchObj
		}).then((response)=>{
			return this._$q.resolve(response.data);
		}, () => {
			return this._$q.reject();
		});
	}

	lista(model, hirReszletesOldal) {
		return this._$http.get(`${this._environment.backendUrl}/do/kereso`, { params: model }).then((response)=>{
			response = angular.copy(response);
			let hirReszletesBaseUrl = response.searchInfos.otpagrar.baseUrl;
			if (response.hits) {
				response.hits = response.hits.map((item)=>{
					item.url = hirReszletesBaseUrl + item.url.replace('{hirReszletesOldal}', hirReszletesOldal);
					return item;
				});
			} else {
				response.hits = [];
			}
			return this._$q.resolve(response);
		});
	}
}

export default angular.module(MODULE_NAME, [])
	.service('keresoService', KeresoService).name;



// WEBPACK FOOTER //
// ./source/applications/kereso/kereso-service.js